import React from 'react';

export default function DefaultBtn(props) {
    return (
        <button
            className='btn toggle-btn'
            aria-pressed={props.currentCounting === props.value}
            aria-label={`set current session to ${props.value.toLowerCase()}.`}
            id={`default-${props.value.toLowerCase()}`}
            onClick={props.handleDefaultBtn}
        >
            {(props.lang === 'en') ? props.value : props.LANG_MAP[props.value]}
        </button>
    )
}